import { createFileRoute, redirect } from "@tanstack/react-router";
import { supabase } from "@/integrations/supabase/client";
import { AdminShell } from "@/components/admin/AdminShell";

/**
 * SDE.4 · Onda 4.4 — Gate raiz de /admin/*.
 *
 * Requer QUALQUER papel administrativo (full | editor | readonly). O nível
 * fino é aplicado por rota-filha e/ou por server function.
 *
 * Autorização REAL vive no servidor (server fns + RLS). Este gate é UX +
 * defesa em profundidade — não deve ser a única barreira.
 */
export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: async () => {
    const { data: userRes } = await supabase.auth.getUser();
    if (!userRes.user) throw redirect({ to: "/auth" });
    // current_admin_level respeita o backfill (admin legado = full) e retorna
    // 'full' | 'editor' | 'readonly' | null.
    const { data: level } = await supabase.rpc("current_admin_level");
    if (!level) throw redirect({ to: "/membros" });
    return { adminLevel: level as "full" | "editor" | "readonly" };
  },
  component: AdminShell,
});
